import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import { Button, Tooltip } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";

import { queryClient } from "App";
import { ModalContext } from "contexts/ModalProvider";
import { useToast } from "hooks/useToast";
import { StockNotification } from "types/models";
import { API } from "utils/api";

type Props = {
  stockNotification: StockNotification;
};

export const ProductStockNotificationDeleteButton = ({
  stockNotification,
}: Props) => {
  const { setConfirmationModalProps } = useContext(ModalContext);
  const { infoToast, errorToast } = useToast();

  const { mutateAsync: deleteStockNotification } = useMutation({
    mutationFn: (stockNotificationId: string) =>
      API.delete(`/stock_notifications/${stockNotificationId}`),
    onSuccess: () => {
      infoToast("Notificación de stock eliminada con éxito.");
      queryClient.invalidateQueries(["stock_notifications"]);
      setConfirmationModalProps({ open: false });
    },
    onError: () =>
      errorToast(
        "No se ha podido eliminar la notificación de stock, intenta nuevamente"
      ),
  });

  const handleDelete = useCallback(() => {
    setConfirmationModalProps({
      open: true,
      title: "Eliminar notificación de stock",
      text: `¿Quieres eliminar la notificación para el producto ${stockNotification.product.name}?`,
      buttonText: "Eliminar",
      buttonColor: "error",
      onSubmit: () => deleteStockNotification(stockNotification.id),
    });
  }, [setConfirmationModalProps, deleteStockNotification, stockNotification]);

  return (
    <Tooltip title="Eliminar Notificación">
      <Button onClick={handleDelete}>
        <AlarmOffIcon titleAccess="Eliminar" />
      </Button>
    </Tooltip>
  );
};
